import { captureMessage } from "@sentry/react";
import { findOnlyOrThrow } from "@dhau/lang-extras";
import type {
	BrickCounts,
	Palette,
} from "@brickme/project-core/src/model/picture.ts";
import type { BrickProduct } from "~/hooks/region/context";

const packSize = 100;

function getColourBricksToBuy(
	brickCounts: BrickCounts | undefined,
	brickProducts: readonly BrickProduct[] | undefined,
	kitsPalette: Palette,
	kitPlusExtrasPalette: Palette,
) {
	return Object.entries(brickCounts ?? {})
		.filter(
			([colour]) => !kitsPalette.some((p) => p.brick.hexString === colour),
		)
		.map(([colour, { count }]) => {
			const brick = findOnlyOrThrow(
				kitPlusExtrasPalette,
				(p) => p.brick.hexString === colour,
				`Couldn't find color ${colour} in kit plus extras palette`,
			).brick;
			const packBricksCount = packSize * Math.ceil(count / packSize);
			const packCount = packBricksCount / packSize;
			let shopifyVariant: BrickProduct["variants"][number] | undefined;
			if (brickProducts !== undefined) {
				const allVariants = brickProducts.flatMap((p) => p.variants);
				shopifyVariant = allVariants.find(
					(v) =>
						v.sku === `B100-${brick.identifier.toString().padStart(2, "0")}`,
				);
				if (shopifyVariant === undefined) {
					captureMessage(
						`Cannot find shopify variant for colour identifier ${brick.identifier}`,
					);
				}
			}
			return {
				brick,
				count,
				packCount,
				packBricksCount,
				shopifyVariant,
			};
		});
}

export { packSize, getColourBricksToBuy };
